export default "__VITE_ASSET__DxjQg2Vm__"